import { useEffect, useMemo, useState } from 'react';
import { api } from '../../services/api';

const SOCIAL_KEYS = [
  { key: 'facebook_url', icon: 'fab fa-facebook-f', label: 'Facebook' },
  { key: 'instagram_url', icon: 'fab fa-instagram', label: 'Instagram' },
  { key: 'youtube_url', icon: 'fab fa-youtube', label: 'YouTube' },
  { key: 'tiktok_url', icon: 'fab fa-tiktok', label: 'TikTok' },
  { key: 'whatsapp_url', icon: 'fab fa-whatsapp', label: 'WhatsApp' },
  { key: 'twitter_url', icon: 'fab fa-x-twitter', label: 'X' },
  { key: 'linkedin_url', icon: 'fab fa-linkedin-in', label: 'LinkedIn' },
];

/** Shared social profile icons from CMS Site Settings */
function SocialLinks({ className = 'th-social', variant = 'default' }) {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    let cancelled = false;
    api.getSettings()
      .then((res) => {
        if (!cancelled) setSettings(res.data || {});
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const links = useMemo(
    () => SOCIAL_KEYS
      .map((item) => ({ ...item, href: (settings[item.key] || '').trim() }))
      .filter((item) => item.href),
    [settings]
  );

  if (links.length === 0) {
    return null;
  }

  return (
    <div className={`${className} twa-social-links twa-social-links--${variant}`}>
      {links.map((item) => (
        <a
          key={item.key}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
          title={item.label}
        >
          <i className={item.icon} />
        </a>
      ))}
    </div>
  );
}

export default SocialLinks;
export { SOCIAL_KEYS };
